import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NavigationEnd } from '@angular/router';
import { Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { CSVDataService } from '@app/export/CSVDataService';
import { MemberofficeService } from '@app/services/memberoffices/memberoffice.service';
import { ReportService } from '@app/services/Reports/Report.service';
import { MenuItem, SelectItem } from 'primeng/api';
import { SnackbarService } from '../../services/shared/snackbar.service';
import { MemberService } from '../../services/member.service';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { Subscription } from 'rxjs/internal/Subscription';

interface GoodStandingResult {
  memberId: number;
  givenName: string;
  familyName: string;
  primaryLodge: string;
  currentLodge: string;
  currentLodgeName: string;
  currentLodgeType: string;
  year: number;
  feeAfterDiscount: number;
  //discount: number;
  yearBalance: number;
  payments: number; //FeeAfterDiscount - YearBalance
  email1: string;
  email2: string;
  webSite: string;
  initiationDate: string;
  createdDate: string;
  mentor: string;
  mentorId: number;
  birthday: string;
  isSubscriber: string;
  localId: number;
  institutionShortName: string;
  institutionName: string;
  institutionVisitingCity: string;
  institutionVisitingCountry: string;
  membershipStartDate: string;
  membershipEndDate: string;
  startCause: string;
  endCause: string;
  checked: boolean;
  phoneHome1: string;
  phoneHome2: string;
  phoneWork: string;
  phoneMobile: string;
}

interface MemberLabelInfo {
  name: string;
  homeCity: string;
  homeCountry: string;
  street: string;
  zipCode: string;
  careOf: string;
}
interface OfficeType {
  id: number;
  name: string;
}

interface Office {
  id: number;
  abbreviation: string;
  name: string;
  type: number;
  sort: number;
}

interface IYear {
  year: number;
}

@Component({
  selector: 'app-gottstaende-tva-report',
  templateUrl: './gottstaende-tva-report.component.html',
  styleUrls: ['./gottstaende-tva-report.component.css']
})
export class GottstaendeTvaReportComponent implements OnInit {
  minmaxyear = { minYear: '1920', maxYear: new Date().getFullYear() + 10 };
  result;
  form;
  
  years: IYear[] = [];
  selectedofficeinstitutions: any[] = [];
  membershipselectedinstitutions: any[] = [];
  nomembershipselectedinstitutions: any[] = [];
  items: MenuItem[];
  expanded = true;
  expandedlabel = 'Stäng grupper';
  officetypelist: OfficeType[] = [];
  officelist: any[] = [];
  committeelist;
  se;
  someorall: SelectItem[];
  displayOfficeInstitutions = false;
  displayMembershipInstitutions = false;
  displayNoMembershipInstitutions = false;
  displayInstitutionChooser = false;
  rangeValues: number[] = [1900, new Date().getFullYear()];
  showMailView: boolean = false;
  can_send_email = false;
  can_view_postals = false;
  selectedmembers: any[] = [];
  subscriptions: Subscription[] = [];
  gsr: GoodStandingResult[] = [];
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private reportService: ReportService,
    private datePipe: DatePipe,
    private memberService: MemberService,
    private memberofficeService: MemberofficeService,
    private snackBarService: SnackbarService,
    private permissionsService: PermissionsService) {
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clear();
      }
    });
    //this.someorall = [{ label: 'både', value: 'all' }, { label: 'någon av', value: 'some' }];
    this.someorall = [{ label: 'någon av', value: 'some' }];
    for (let i = this.rangeValues[1]; i > this.rangeValues[0] - 1; i--) {
      // this.years.push({ year: i });
      this.years.push({ year: i });
    }
  }

  ngOnInit() {
    this.form = this.fb.group({
      officeTypeId: ['', ''],
      officeId: ['', Validators.required],
      committeeId: ['', ''],
      officeInstitutions: ['', ''],
      officeStartPeriodFrom: ['', ''],
      officeStartPeriodTo: ['', ''],
      officeEndPeriodFrom: ['', ''],
      officeEndPeriodTo: ['', ''],
      membershipSomeOrAll: ['some', ''],
      membershipInstitutions: ['', ''],
      membershipStartedFrom: ['', ''],
      membershipStartedTo: ['', ''],
      membershipEndedFrom: ['', ''],
      membershipEndedTo: ['', ''],
      nomembershipSomeOrAll: ['some', ''],
      noMembershipInstitutions: ['', ''],
      noMembershipStartedFrom: ['', ''],
      noMembershipStartedTo: ['', ''],
      noMembershipEndedFrom: ['', ''],
      noMembershipEndedTo: ['', ''],
      parentInstitutionId: ['', ''],
      institutionId: ['', ''],
      memberYear: [new Date().getFullYear(), ''],
      reportType: ['all', ''],
      institutionTypeId: ['', '']
    });
    
    this.se = {
      firstDayOfWeek: 1,
      dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
      dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
      dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
      monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'I dag',
      clear: 'Rensa',
      dateFormat: 'yy-mm-dd',
      weekHeader: 'Vecka'
    };
    for (let i = this.rangeValues[1]; i > this.rangeValues[0] - 1; i--) {
      // this.years.push({ year: i });
      this.years.push({ year: i });
      this.form.get('memberYear').setValue(this.years[0].year);
    }
    this.permissionsService.selectedrole.subscribe(r => {
      if (r) {
        this.setPermissions();
      }
    });
   // this.setPermissions();
    this.getOfficesTypes();
    this.getOffices();
    this.getCommittees();
    this.setItems();
  }

  clear() {
    this.form?.reset();
    this.membershipselectedinstitutions = [];
    this.nomembershipselectedinstitutions = [];
    this.form?.patchValue({ membershipInstitutions: null });
    this.form?.patchValue({ noMembershipInstitutions: null });
    this.form?.patchValue({ reportType: 'all' });
    this.form?.patchValue({ memberYear: new Date().getFullYear() });
    this.gsr = [];
    this.ngOnInit();
  }

  removeSelectedOfficeInstitution(id: number) {
    const idx = this.selectedofficeinstitutions.findIndex(x => x.id === id);
    this.selectedofficeinstitutions.splice(idx, 1);
  }

  setDate(first, second) {
    const datum = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.form.get(first).patchValue(datum);
    this.form.get(second).patchValue(datum);
  }

  closeEmail(evt: any) {
    this.showMailView = false;
    this.setItems();
  }

  search() {
    const membershipinstitutions: number[] = [];
    this.membershipselectedinstitutions.forEach(i => {
      membershipinstitutions.push(i.id);
    });
    const nomembershipinstitutions: number[] = [];
    this.nomembershipselectedinstitutions.forEach(i => {
      nomembershipinstitutions.push(i.id);
    });
    const officeinstitutions: any[] = [];
    this.selectedofficeinstitutions.forEach(i => {
      officeinstitutions.push(i.id);
    });

    this.form.get('officeInstitutions').patchValue(officeinstitutions as any);
    this.form.get('membershipInstitutions').patchValue(membershipinstitutions as any);
    this.form.get('noMembershipInstitutions').patchValue(nomembershipinstitutions as any);

    this.reportService.GetGoodStanding2Report(this.form.value).subscribe(response => {
      if (typeof response === 'string') {
        this.gsr = [];
        this.snackBarService.openSnackBar(response, null, 'info', 5000);
      } else {
        this.gsr = response;
        let lastmemberid;
        this.gsr.forEach(mr => {
          mr['checked'] = false;

          if (mr.memberId !== lastmemberid) {
            mr['checkbox'] = true;
            lastmemberid = mr.memberId;
          }
        });
        this.setItems();
      }
    });
  }

  add(member, element) {
    if (element.checked) {
      if (!this.checkMember(member.memberId)) {
        this.selectedmembers.push(member);
        const idx = this.gsr.findIndex(m => m.memberId === Number(member.memberId));
        this.gsr[idx].checked = true;
      }
    } else {
      this.removeFromArray(member.memberId);
    }
    this.setItems();
  }

  removeFromArray(id: number) {
    const idx = this.selectedmembers.findIndex(item => item.id === id);
    this.selectedmembers.splice(idx, 1);
    const index = this.gsr.findIndex(m => m.memberId === id);
    if (index !== -1) {
      this.gsr[index].checked = false;
    }
  }

  checkMember(memberid: number) {
    return this.selectedmembers.find(item => item.id === memberid);
  }
  checkuncheckAll(element) {
    let value = false;
    let memberid;
    element.checked ? value = true : value = false;
    for (const m of this.gsr) {
      m.checked = value;
      if (m.memberId !== memberid) {
        this.add(m, element);
      }
      memberid = m.memberId;
    }
  }

  sortData(sort: Sort) {
    const data = this.gsr.slice();
    if (!sort.active || sort.direction === '') {
      this.gsr = data;
      return;
    }

    this.gsr = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'memberId': return this.compare(a.memberId, b.memberId, isAsc);
        case 'givenname': return this.compare(a.givenName, b.givenName, isAsc);
        case 'familyname': return this.compare(a.familyName, b.familyName, isAsc);
        case 'fullypaid': return this.compare(a.yearBalance >= 0, b.yearBalance >= 0, isAsc);
        case 'primaryLodge': return this.compare(a.primaryLodge, b.primaryLodge, isAsc);
        case 'currentLodge': return this.compare(a.currentLodge, b.currentLodge, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string | Date | boolean, b: number | string | Date | boolean, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }, {
        label: 'Etiketter',
        icon: 'fa fa-id-card',
        visible: this.gsr.length > 0,
        command: () => this.createLabels()
      }, {
        label: 'Epost',
        icon: 'fa fa-envelope',
        command: () => this.sendMail(),
        visible: this.selectedmembers.length > 0 && this.can_send_email
      }];
  }

  setPermissions() {
    const userid = this.permissionsService.userid;
    const user_permissions = JSON.parse(sessionStorage.getItem('selectedrole')).permissions;
    this.can_view_postals = user_permissions.indexOf('VIEW_POSTALS') !== -1;
    this.can_send_email = user_permissions.indexOf('SEND_EMAIL') !== -1;
    this.setItems();
    /*let can_view_postals_observable = this.permissionsService.hasPermissionForMember('VIEW_POSTALS', userid);
    let can_send_email_observable = this.permissionsService.hasPermissionForMember('SEND_EMAIL', userid);
    this.subscriptions.push(forkJoin([
      can_view_postals_observable,
      can_send_email_observable,
    ]).subscribe(response => {
      this.can_view_postals = response[0];
      this.can_send_email = response[1];
      this.setItems();
    }));*/
  }
  sendMail() {
    this.showMailView = true;
  }

  exportToCSV() {
    const firstrow = 'Medlemsnr;Förnamn;Efternamn;Primärloge;Aktuell loge (kort);Aktuell loge;Logetyp;År;Årsavgift;Skuld(-) Fordran(+);Betalt totalt;Email1;Email2;Telefon hem 1;Telefon hem 2;Telefon jobb;Telefon mobil';
    const datum = new Date();
    const filnamn = 'OF_Gottstaende2_' + datum.getFullYear() + datum.getMonth() + datum.getDay();
    CSVDataService.exportToCsv(filnamn + '.csv', this.gsr, firstrow);
  }

  createLabels() {
    let idlista: any[] = [];
    this.gsr.forEach(x => {
      idlista.push(x.memberId);
    });
    this.memberService.GetMemberInfoFromMemberIds(idlista).subscribe(x => {
      if (x) {
        let memberlista: MemberLabelInfo[] = [];
        x.forEach(i => {
          const data = {
            name: i.givenName + ' ' + i.familyName,
            careOf: i.careOf,
            street: i.street,
            zipCode: i.zipCode,
            homeCity: i.homeCity,
            homeCountry: i.homeCountry
          };
          memberlista.push(data);
        });
        const firstrow = 'Namn;C/O;Gatuadress;Postnummer;Ort;Land';
        const filnamn = 'OF_Etikettdata_gottstaende2';
        CSVDataService.exportToCsv(filnamn + '.csv', memberlista, firstrow);
      }
    });
  }


  getOfficesTypes() {
    this.memberofficeService.GetOfficesTypes().subscribe(response => {
      this.officetypelist = response;

    });
  }

  getOffices() {
    this.memberofficeService.GetOffices().subscribe(response => {
      this.officelist = response;

      this.officelist.forEach(x => {
        x.officeName = x.committeeName + ': ' + x.officeName;
      });
      // tslint:disable-next-line: max-line-length
      this.officelist.unshift({ committeId: null, committeeName: null, id: null, officeId: null, officeName: null, officeTypeName: null, sort: null });
    });
  }


  getOfficesByOfficeType(evt) {
    this.memberofficeService.GetOfficesByOfficeType(evt.target.value).subscribe(resp => {
      this.officelist = resp;
      this.officelist.forEach(x => {
        x.officeName = x.committeeName + ': ' + x.officeName;
      });
      // tslint:disable-next-line: max-line-length
      this.officelist.unshift({ committeId: null, committeeName: null, id: null, officeId: null, officeName: null, officeTypeName: null, sort: null });

    });
  }

  getCommittees() {
    this.memberofficeService.Committees().subscribe(response => {
      this.committeelist = response;
    });
  }

  getCommitteesByOfficeId(evt) {
    if (evt.value?.officeId) {
      this.form.patchValue({ officeId: evt.value });
      this.memberofficeService.getCommitteesByOfficeId(evt.value?.officeId).subscribe(resp => {
        this.committeelist = resp;
      });
    } else {
      this.getOffices();
      this.getCommittees();
    }
  }

  setSelectedInstitutions(evt, institutionlist) {
    switch (institutionlist) {
      case 'membership': this.membershipselectedinstitutions = evt;
        break;
      case 'office': this.selectedofficeinstitutions = evt;
        break;
    }
  }
  setSelectedNoInstitutions(evt, institutionlist) {
    switch (institutionlist) {
      case 'nomembership': this.nomembershipselectedinstitutions = evt;
        const insts = [];
        evt.forEach(x => {
          if (x) {
            insts.push(x.id);
          }
        });
        this.form.patchValue({ noMembershipInstitutions: insts.toString() });
        break;
    }
  }
  removeNoMembershipSelectedInstitution(id: number) {
    const idx = this.nomembershipselectedinstitutions.findIndex(x => x.id === id);
    this.nomembershipselectedinstitutions.splice(idx, 1);
    const insts = [];
    this.nomembershipselectedinstitutions.forEach(x => {
      if (x) {
        insts.push(x.id);
      }
    });
    this.form.patchValue({ noMembershipInstitutions: insts.toString() });
  }
}
